var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "container wrapper w-full flex flex-col items-center relative",
      style: _vm.scrollableHeightStyle
    },
    [
      _c(
        "div",
        {
          staticClass:
            "hidden lg:block fixed bottom-[-30px] left-[42px] text-center selector-f"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", {
            staticClass: "h-[54px] w-[54px] mb-[5px] relative z-10",
            domProps: { innerHTML: _vm._s(_vm.svg("circle")) }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "h-[54px] w-[54px] relative z-10",
            domProps: { innerHTML: _vm._s(_vm.svg("circle")) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "hidden lg:block fixed self-start lg:ml-[100px] xl:ml-0 bottom-[50px] lg:bottom-16 xl:bottom-[50px] selector-f"
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-wrap gap-16" },
            _vm._l(_vm.links, function(link, index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass:
                    "px-[25px] py-[14px] flex items-center gap-8 group font-semi",
                  class: link.link.class,
                  attrs: { href: link.link.url }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(link.link.title) +
                      "\n                "
                  ),
                  _c("i", {
                    staticClass:
                      "fas fa-chevron-right text-12 text-brown-400 group-hover:mr-[-8px] group-hover:ml-[8px] transition-all"
                  })
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "hidden lg:block fixed self-start selector-f floating-menu",
          class: _vm.gtmClass
        },
        [
          _vm.showBreadcrumbs
            ? _c(
                "div",
                {
                  staticClass: "text-16 flex flex-wrap gap-8 items-center mb-16"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "font-regular hover:text-orange transition-colors",
                      attrs: { href: "/" }
                    },
                    [_vm._v("home")]
                  ),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "fas fa-chevron-right text-brown-400 text-14"
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-orange font-semi lowercase" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.pageTitle) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.title
            ? _c(
                "h1",
                {
                  staticClass:
                    "lg:text-40 leading-none xl:text-70 font-extraBold mb-0 xl:mb-24 text-brown-400"
                },
                [_vm._v(_vm._s(_vm.title))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.description
            ? _c(
                "p",
                { staticClass: "text-18 font-medium mb-40 max-w-[369px]" },
                [_vm._v(_vm._s(_vm.description))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.items, function(item, index) {
            return _c(
              "div",
              {
                key: index + "_link",
                staticClass:
                  "group font-semi text-20 mb-16 text-brown-400 cursor-pointer ",
                class: { "!text-orange": index === _vm.step },
                on: {
                  click: function($event) {
                    return _vm.scrollTo(index)
                  }
                }
              },
              [
                _vm._v(
                  "\n            " + _vm._s(item.title) + "\n            "
                ),
                _c("i", {
                  staticClass:
                    "fas fa-chevron-right text-16 ml-8 group-hover:ml-16 transition-all"
                })
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "hidden lg:block fixed top-[-301px] right-[-400px] xl:right-[-301px] selector-c z-70 h-[613px] w-[613px] xl:h-[813px] xl:w-[813px]",
        domProps: { innerHTML: _vm._s(_vm.svg("circle")) }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "hidden lg:block fixed top-[400px] xl:top-[600px] right-[-400px] xl:right-[-301px] selector-c z-50 h-[613px] w-[613px] xl:h-[813px] xl:w-[813px]",
        domProps: { innerHTML: _vm._s(_vm.svg("circle")) }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "hidden lg:block fixed top-[1080px] xl:top-[1510px] right-[-400px] xl:right-[-301px] selector-c z-50 h-[613px] w-[613px] xl:h-[813px] xl:w-[813px]",
        domProps: { innerHTML: _vm._s(_vm.svg("circle")) }
      }),
      _vm._v(" "),
      _vm._l(_vm.filteredItems, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass:
              "selector-word text-orange flex items-center justify-center h-[120px] w-[50vw] transition-opacity",
            staticStyle: { opacity: "0" }
          },
          [
            _c(
              "h3",
              { staticClass: "text-80 lg:text-120 font-black relative" },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "text-70 lg:text-120 font-black absolute right-[42px] lg:right-[78px] top-0"
                  },
                  [_vm._v(_vm._s(item.part_left))]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "opacity-0" }, [_vm._v("e")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "text-70 lg:text-120 font-black absolute left-[34px] lg:left-[78px] top-0"
                  },
                  [_vm._v(_vm._s(item.part_right))]
                )
              ]
            )
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "selector-e floating fixed flex flex-col text-center items-center top-0"
        },
        _vm._l(_vm.items, function(item, index) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: index === _vm.step,
                  expression: "index === step"
                }
              ],
              key: index + "_text",
              staticClass: "selector-text justify-center",
              class: _vm.gtmClass
            },
            [
              _c(
                "h4",
                { staticClass: "title uppercase font-semi text-26 mb-40" },
                [_vm._v(_vm._s(item.title))]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "mb-0 max-w-[560px] xl:max-w-[668px]" }, [
                _vm._v(_vm._s(item.description))
              ]),
              _vm._v(" "),
              item.link && item.link.url
                ? _c(
                    "a",
                    {
                      staticClass:
                        "bg-orange rounded-full text-white px-[25px] py-[14px] font-semi inline-block mt-[40px] hover:opacity-75 transition-opacity",
                      attrs: {
                        "data-service-info": item.title.toLowerCase(),
                        href: item.link.url
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.link.title) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._m(1)
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "bg-gray-100 text-brown-400 text-20 pb-[13px] mb-[-13px] relative z-20 flex flex-col gap-[4px]"
      },
      [
        _c("span", [_vm._v("weg")]),
        _vm._v(" "),
        _c("span", [_vm._v("van")]),
        _vm._v(" "),
        _c("span", [_vm._v("cijfers")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "selector-e flex flex-wrap fixed  left-0 right-0 top-0 bottom-0 w-[42px] lg:w-[75px] h-[120px] m-auto"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "text-center text-50 absolute font-extraLight bottom-[100px] left-[-8px] lg:left-0"
          },
          [
            _c("div", [_vm._v("ik")]),
            _vm._v(" "),
            _c("div", [_vm._v("wil")]),
            _vm._v(" "),
            _c("div", [_vm._v("het")])
          ]
        ),
        _vm._v(" "),
        _c(
          "h3",
          { staticClass: "text-orange text-70 lg:text-120 font-black main-e" },
          [_vm._v("e")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }